// src/components/FreeLimitModal.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';

export default function FreeLimitModal({ onClose }) {
  const navigate = useNavigate();

  const options = [
    { id: 'MONTHLY', emoji: '📅', label: 'Monthly Unlimited', price: '₹99/month', originalPrice: '₹199', desc: 'Unlimited questions · Launch Offer', color: '#1E40AF', bg: '#EFF6FF' },
    { id: 'QUARTERLY', emoji: '⭐', label: 'Quarterly — Most Popular', price: '₹249/3 months', originalPrice: '₹499', desc: '₹83/month effectively', color: '#7C3AED', bg: '#F5F3FF' },
    { id: 'ANNUAL', emoji: '🌟', label: 'Annual — Best Value', price: '₹499/year', originalPrice: '₹999', desc: '₹42/month effectively', color: '#D97706', bg: '#FFFBEB' },
  ];

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <div>
            <div style={styles.title}>⚠️ Free Limit Reached</div>
            <div style={styles.subtitle}>Aaj ke 5 free sawaal poore ho gaye</div>
          </div>
          <button style={styles.closeBtn} onClick={onClose}><X size={20} color="#6B7280" /></button>
        </div>

        <p style={styles.desc}>Apna jawab paane ke liye choose karein:</p>

        <div style={styles.options}>
          {options.map(opt => (
            <button
              key={opt.id}
              style={{ ...styles.optionBtn, background: opt.bg, borderColor: opt.color }}
              onClick={() => { onClose(); navigate('/plans'); }}
            >
              <span style={styles.optEmoji}>{opt.emoji}</span>
              <div style={styles.optInfo}>
                <div style={{ ...styles.optLabel, color: opt.color }}>{opt.label}</div>
                <div style={styles.optDesc}>{opt.desc}</div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <div style={{ ...styles.optPrice, color: opt.color }}>{opt.price}</div>
                {opt.originalPrice && (
                  <div style={{ fontSize: 11, color: '#94A3B8', textDecoration: 'line-through' }}>{opt.originalPrice}</div>
                )}
              </div>
            </button>
          ))}
        </div>

        <p style={styles.resetNote}>Free limit kal midnight par reset hogi 🌙</p>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 100, display: 'flex', alignItems: 'flex-end' },
  modal: { background: '#FFF', borderRadius: '24px 24px 0 0', padding: '24px 20px 36px', width: '100%', maxHeight: '85vh', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 },
  title: { fontSize: 18, fontWeight: 800, color: '#111827' },
  subtitle: { fontSize: 13, color: '#6B7280', marginTop: 4 },
  closeBtn: { background: 'none', border: 'none', cursor: 'pointer', padding: 4 },
  desc: { fontSize: 14, color: '#374151', marginBottom: 16 },
  options: { display: 'flex', flexDirection: 'column', gap: 10 },
  optionBtn: { display: 'flex', alignItems: 'center', gap: 12, padding: '14px 14px', border: '2px solid', borderRadius: 14, cursor: 'pointer', textAlign: 'left', width: '100%' },
  optEmoji: { fontSize: 22, flexShrink: 0 },
  optInfo: { flex: 1 },
  optLabel: { fontSize: 14, fontWeight: 700 },
  optDesc: { fontSize: 12, color: '#6B7280', marginTop: 2 },
  optPrice: { fontSize: 14, fontWeight: 800, flexShrink: 0 },
  resetNote: { textAlign: 'center', fontSize: 12, color: '#9CA3AF', marginTop: 16 },
};
